export function uiaaLeadScore (a, b) {
  if (typeof a !== 'string') a = ''
  if (typeof b !== 'string') b = ''

  function match (s) {
    const m = s.match(/(TOP|[\d.]+)(?:\((.+)\))?/i)
    if (!m) return {h: 0, t: 0}
    return {
      h: m[1].toLowerCase() === 'top' ? Number.MAX_VALUE : parseFloat(m[1]),
      t: parseFloat(m[2])
    }
  }

  a = match(a)
  b = match(b)
  if (a.h !== b.h) return b.h - a.h
  if (a.t !== b.t) return a.t - b.t
  return 0
}

export default {
  uiaaLeadScore
}



// WEBPACK FOOTER //
// ./src/utils/comparators.js